module.exports = __webpack_public_path__ + "static/media/Senegal.c912ec71.png";